import React from "react";
import { Navigate } from "react-router-dom";
// import AuthContext from "../../context/auth_context";
import ThemeWrapperAdmin from "../../components/Admin/UI/ThemeWrapperAdmin";
// import { useDispatch } from "react-redux";
// import checkToken from "../checkToken";
import { useSelector } from "react-redux";
import AuthSplash from "../../components/Admin/Reusable/AuthSplash";
import { canEmployeeAccessPath, isEmployee } from "../auth";

const AdminRoute = ({
  redirectPath = "/",
  component: Component,
  ...otherProps
}) => {
  const { isAuthenticated, loggedUser, checking } = useSelector(
    (state) => state.loggedUserReducer
  );

  if (checking) return <AuthSplash />;
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (
    isEmployee(loggedUser) &&
    !canEmployeeAccessPath(window.location.pathname)
  ) {
    return <Navigate to="/receipt-list" replace />;
  }

  return (
    <div className="main-content main-content-admin">
      <ThemeWrapperAdmin>
        <Component {...otherProps} />
      </ThemeWrapperAdmin>
    </div>
  );
};

export default AdminRoute;
